export default function revealPerson( output, person, formId, result ) {
  result.innerHTML = output;
  result.classList.remove('bravo-marknadsinformation-gf__result--loading');
  if (person && typeof person === 'object') {
      Object.entries(person).forEach(([key, value]) => {
        if (key.endsWith('.1')) return; // Do not obfuscate personal identity number input
        let input = document.getElementById(`input_${formId}_${key}`);
        if (input !== undefined && input !== null) {
            input.value = value;
        }
      });
  }
}